import { ErrorHandler, Injectable, NgZone, inject } from '@angular/core';
import { PosthogService } from './posthog.service';

declare global {
  interface Window {
    /** Defined by the boot script in index.html; reloads on stale-chunk errors. */
    __recoverFromChunkError?: (error: unknown) => boolean;
  }
}

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly zone = inject(NgZone);
  private readonly posthogService = inject(PosthogService);

  handleError(error: unknown): void {
    const recovered = this.zone.runOutsideAngular(
      () => window.__recoverFromChunkError?.(error) ?? false
    );
    if (recovered) {
      return;
    }

    // Log other errors as normal
    console.error(error);

    try {
      this.posthogService.client.captureException(
        error instanceof Error ? error : new Error('Unknown application error')
      );
    } catch (error) {
      console.error('Error capturing error in PostHog:', error);
    }

  }
}
